import React from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { SITE, ROUTES } from "../data/siteConfig";
import { ChevronRight, MessageCircle } from "lucide-react";

/**
 * Standard-Layout für Inhaltsseiten: Header, Breadcrumb (optional), Hauptinhalt, CTA, Footer.
 */
const PageLayout = ({
  children,
  breadcrumbs = null,
  ctaTitle = "Kostenlose Marketing-Beratung",
  ctaSubtitle = "Digitale Strategie anfragen oder Social Media Analyse anfordern – wir melden uns innerhalb von 24 Stunden.",
  showCta = true,
}) => {
  return (
    <div className="min-h-screen bg-[#fafafa] flex flex-col">
      <Header />
      <main
        className="flex-1 section-spacing"
        style={{ paddingTop: "calc(var(--header-height, 6rem) + 2rem)" }}
      >
        <div className="container-custom">
          {breadcrumbs && breadcrumbs.length > 0 && (
            <nav
              className="mb-8 text-sm text-[#3a3a3a]/80"
              aria-label="Breadcrumb"
            >
              <ol className="flex flex-wrap items-center gap-2">
                <li>
                  <Link to="/" className="text-[#4a9da8] hover:text-[#2c4a52] hover:underline">
                    Start
                  </Link>
                </li>
                {breadcrumbs.map(({ label, path }, i) => (
                  <li key={i} className="flex items-center gap-2">
                    <ChevronRight className="w-4 h-4 text-[#3a3a3a]/50" aria-hidden />
                    {path ? (
                      <Link to={path} className="text-[#4a9da8] hover:text-[#2c4a52] hover:underline">
                        {label}
                      </Link>
                    ) : (
                      <span className="text-[#0f1419] font-medium">{label}</span>
                    )}
                  </li>
                ))}
              </ol>
            </nav>
          )}
          {children}
          {showCta && (
            <section className="mt-16 md:mt-20 py-12 px-6 rounded-2xl bg-gradient-to-br from-[#0f1419] to-[#2c4a52] text-center">
              <h2 className="text-2xl md:text-3xl font-bold text-white mb-3">
                {ctaTitle}
              </h2>
              <p className="text-white/80 max-w-xl mx-auto mb-6">
                {ctaSubtitle}
              </p>
              <Link
                to="/#kontakt"
                className="inline-flex items-center gap-2 px-6 py-3 bg-[#4a9da8] text-white font-semibold rounded-xl hover:bg-[#3d8a94] transition-colors"
              >
                <MessageCircle className="w-5 h-5" />
                Kontakt aufnehmen
              </Link>
            </section>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PageLayout;
